import { SocketContext } from "@/Context/SocketContext";
import { FC, useCallback, useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const requiredScopes = [
    // Kanalpunkte
    "channel:manage:redemptions",
    "channel:read:redemptions",
    // Hypetrain
    "channel:read:hype_train",
    // Chat
    "chat:read",
    "chat:edit",
    "user:bot",
    "channel:bot",
    "user:read:chat",
    // Subs
    "channel:read:subscriptions",
    // Bits
    "bits:read",
    // Follows
    "user:read:follows",
    "moderator:read:followers",
    // Goals
    "channel:read:goals",
    // Whispers
    // "whispers:read",
    // "whispers:edit",
    // "user:manage:whispers",
    // Polls
    "channel:read:polls",
    "channel:manage:polls",
    // Predictions
    "channel:read:predictions",
    "channel:manage:predictions",
    // Moderation (timeout, pin, etc)
    // "moderation:read",
    // "channel:moderate",
    // "moderator:manage:banned_users",    // Doubt
    // "moderator:read:chat_settings",     // Doubt
    // "moderator:manage:chat_settings",   // Doubt
    // "channel:manage:moderators",        // Doubt
    "moderator:read:followers",            // Follower Alert
    // Editors
    // "channel:read:editors",             // Doubt
    // VIPs
    // "channel:read:vips",                // VIP des Tages
    // "channel:manage:vips",              // VIP des Tages
    // Chatters
    "moderator:read:chatters",             // Getting random users
    // Tags und Co
    // "channel:manage:broadcast",         // Doubt
    // "channel:read:stream_key",          // Doubt
    // Clips
    // "clips:edit",                       // Maybe Future
    // Shoutouts
    "moderator:read:shoutouts",
    "moderator:manage:shoutouts",
    // Anouncements
    "moderator:manage:announcements",
    
    // "user:edit",                        // Doubt
] as const;

const getAuthUrl = () => {
    const clientId = import.meta.env.VITE_TWITCH_CLIENT_ID;
    const overlayUrl = import.meta.env.VITE_OVERLAY_URL;
    const scopeString = encodeURIComponent(requiredScopes.join(" "));

    return `https://id.twitch.tv/oauth2/authorize?client_id=${clientId}&redirect_uri=${overlayUrl}/authorize&response_type=code&force_verify=true&scope=${scopeString}`;
}

export const Twitch: FC = () => {
    const [searchParams] = useSearchParams();
    const [authorized, setAuthorized] = useState(searchParams.get("authorized") === "true");
    const socket = useContext(SocketContext);

    useEffect(() => {
        socket.emit("is-twitch-authenticated", (result) => {
            setAuthorized(result);
        });

        const t = setInterval(() => {
            socket.emit("is-twitch-authenticated", (result) => {
                setAuthorized(result);
            });
        }, 5000);

        return () => {
            clearInterval(t);
        }
    }, [socket]);

    const handleSave = useCallback(() => {
        globalThis.location.href = getAuthUrl();
    }, []);

    return (
        <div className="max-h-screen min-w-xl flex flex-col items-center justify-center">
            <h1 className="text-4xl text-center" aria-label="Twitch Setup">
                Twitch Setup
            </h1>

            { authorized ? (
                <p className="text-green-500 mt-4">
                    Twitch account successfully authorized! No further action is required.
                </p>
            ) : (
                <>
                    <p className="text-center mt-4">
                        To set up Twitch authentication, please click the "Authorize Bot" button below and follow the instructions.<br/>
                        You will be asked to log in with your Twitch account and grant the necessary permissions to the bot.<br/>
                        After successful authentication, your overlay should be able to receive subscriber and cheer events from Twitch, and the Chat Alerts should work properly.<br/>
                    </p>
                    <div className="flex flex-row items-center justify-center mt-4 w-full max-w-md">
                        <button
                            className="ml-2 px-4 py-2 bg-violet-500 text-white rounded hover:bg-violet-600 transition"
                            onClick={handleSave}
                        >
                            Authorize Bot
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}